export default "__VITE_ASSET__CLqT6s5r__"